import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Config comes from .env.development (`npm start` → beta) or .env.production
// (`npm run build` → production). See .env.example for the variable list.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

if (process.env.NODE_ENV === "development") {
  console.log(
    `[BoneFlow] Connected to Firebase project: ${firebaseConfig.projectId || "(none)"}`
  );
  const missing = Object.entries(firebaseConfig)
    .filter(([, value]) => !value)
    .map(([key]) => key);
  if (missing.length > 0) {
    console.warn(
      `[BoneFlow] Missing Firebase config: ${missing.join(", ")} — check .env.development and restart the dev server.`
    );
  }
}

const app = initializeApp(firebaseConfig);

// Auth and Firestore are eager on purpose: AuthContext subscribes to both on the
// first tick, so every render path already waits on them. Storage and Functions
// are NOT initialized here — this module is in the main chunk, and initializing
// them at module scope put both SDKs on a signed-out visitor's critical path.
// They load on first use instead; see `firebaseLazy.js`.
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
